const runtimeOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : '';
const shareBaseUrl = process.env.SHARE_BASE_URL || runtimeOrigin;

export default {
    // 从环境变量中获取 API 地址
    api: process.env.API_BASE_URL,
    // 统一管理 H5 分享域名
    shareBaseUrl,
    shareBlankUrl: shareBaseUrl ? `${shareBaseUrl}/index.html#/blank` : '/index.html#/blank',
    // api: 'http://192.168.1.254:8700',
}



// WEBPACK FOOTER //
// ./src/serve.js